import { Link } from "react-router-dom";
import { PATTERNS } from "../i18n";

export const ProductCard = ({ product, locale, index = 0 }) => (
  <Link
    to={`/${locale}/${PATTERNS[locale].product}/${product.slug}`}
    data-testid={`product-card-${product.id}`}
    className="group block"
  >
    <div className="overflow-hidden bg-plaster-deep relative">
      {product.sale_percent ? (
        <span className="absolute top-3 start-0 bg-ink text-plaster text-[11px] tracking-[0.14em] uppercase px-3 py-1 z-10"
              data-testid={`sale-ribbon-${product.id}`}>
          −{product.sale_percent}%
        </span>
      ) : null}
      <img
        src={product.images?.[0]}
        alt={product.title}
        loading={index < 4 ? "eager" : "lazy"}
        className="w-full aspect-[4/5] object-cover scale-100 group-hover:scale-[1.03] transition-transform duration-500 ease-out"
      />
    </div>
    <div className="pt-4 space-y-1">
      <h3 className="font-display text-xl text-ink">{product.title}</h3>
      <p className="text-sm text-muted">
        {product.type_label} · {product.city?.name}
      </p>
      <p className="text-base text-charcoal tabular">
        {product.symbol} {product.price}
        {product.compare_at ? <span className="text-muted line-through ms-2 text-sm">{product.compare_at}</span> : null}
      </p>
    </div>
  </Link>
);

export default ProductCard;
